import styled from 'styled-components';

import InvestorFirmsSearch from '../../../../common/components/form/investor-firm-search/InvestorFirmSearch';

export const StyledInvestorSelect = styled(InvestorFirmsSearch)`
  flex-basis: 60%;
`;
export const SInvestorSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

export const SInvestorSearchLabel = styled.div`
  border: ${({ theme }) => `${theme.border.width.small} solid ${theme.border.color.dark}`};
  padding: 6px 10px;
  border-radius: 4px;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${({ theme }) => theme.background.color.light};
  color: ${({ theme }) => theme.text.color.placeholder};
`;
